// extracted by mini-css-extract-plugin
export default {"coverOurMenuItem":"our-menu-item_coverOurMenuItem__dfvDO","coverTitle":"our-menu-item_coverTitle__T1DKW"};